import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
const OtherServices = /*#__PURE__*/ React.lazy(()=>import('../modules/OtherServices/index'));
export const OtherServicesRoutes = ()=>[
        {
            path: 'other-services/*',
            component: /*#__PURE__*/ _jsx(OtherServices, {})
        }
    ];
